<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import CoreIcon from '@core/core-icon.vue';

const { t } = useI18n();
</script>

<template>
	<router-link to="/invite" class="part-invite-promo-gradient-compact">
		<div class="part-invite-promo-gradient-compact__glow"></div>
		<div class="part-invite-promo-gradient-compact__icon">
			<core-icon name="sale" viewBox="0 0 18 18" />
		</div>
		<div class="part-invite-promo-gradient-compact__text">
			<div class="part-invite-promo-gradient-compact__title">
				{{ t('accountIndex.invite_promo.title_short') }}
			</div>
			<div class="part-invite-promo-gradient-compact__subtitle">
				{{ t('accountIndex.invite_promo.subtitle') }}
			</div>
		</div>
		<core-icon name="arrowRight" viewBox="0 0 13 22" class="part-invite-promo-gradient-compact__arrow" />
	</router-link>
</template>

<style lang="scss">
.part-invite-promo-gradient-compact {
	display: flex;
	align-items: center;
	gap: 1.4rem;
	position: relative;
	overflow: hidden;
	border-radius: 1.8rem;
	padding: 1.4rem 1.6rem;
	color: #fff;
	background:
		radial-gradient(120% 120% at 100% 0%, rgba(255, 255, 255, 0.18) 0%, transparent 60%),
		linear-gradient(203.74deg, #FA9DF1 -1.83%, #E06EFE 26.73%, #B45DFF 50.76%, #7E2EFF 79.87%, #6125ED 97.38%);
	box-shadow: 0 0.8rem 2.4rem rgba(126, 46, 255, 0.24);
	text-decoration: none;
	transition: transform 0.2s ease, box-shadow 0.2s ease;

	&:hover {
		transform: translateY(-1px);
		box-shadow: 0 1.2rem 3rem rgba(126, 46, 255, 0.32);
		color: #fff;
	}
	&:active {
		transform: translateY(0);
	}

	&__glow {
		position: absolute;
		top: -4rem;
		right: -4rem;
		width: 12rem;
		height: 12rem;
		border-radius: 50%;
		background: radial-gradient(circle, rgba(255, 255, 255, 0.3) 0%, transparent 65%);
		pointer-events: none;
	}

	&__icon {
		flex: 0 0 auto;
		width: 4rem;
		height: 4rem;
		border-radius: 50%;
		background: rgba(255, 255, 255, 0.2);
		backdrop-filter: blur(8px);
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
		z-index: 1;

		.icon {
			width: 2rem;
			height: 2rem;
			fill: #fff;
		}
	}

	&__text {
		flex: 1 1 auto;
		min-width: 0;
		position: relative;
		z-index: 1;
	}

	&__title {
		font-size: 1.5rem;
		font-weight: 600;
		line-height: 1.2;
		margin-bottom: 0.2rem;
	}

	&__subtitle {
		font-size: 1.2rem;
		line-height: 1.3;
		opacity: 0.88;
	}

	&__arrow {
		flex: 0 0 auto;
		width: 0.8rem;
		height: 1.4rem;
		fill: #fff;
		opacity: 0.9;
		position: relative;
		z-index: 1;
	}

	@include min-desktop {
		padding: 1.6rem 2rem;

		&__title {
			font-size: 1.6rem;
		}
		&__subtitle {
			font-size: 1.3rem;
		}
	}
}
</style>
